import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { CreateMembershipGroupCardFormSchemaValues as FormSchemeValues } from 'src/features/memberships/api/useCreateMembershipGroupCard';
import type { MembershipGroupCard } from 'src/features/memberships/types';
import type { GeneralSmartParkError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/cards/:membershipGroupCardId/';

interface DTO extends FormSchemeValues {
    parkingId: string;
    membershipGroupId: number;
    membershipGroupCardId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({
    parkingId,
    membershipGroupId,
    membershipGroupCardId,
    ...data
}: DTO): Promise<MembershipGroupCard> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipGroupId, membershipGroupCardId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_MEMBERSHIP_GROUP_CARD_RESOURCE, useMutationHook as useUpdateMembershipGroupCard };
export type { DTO as UpdateMembesrhipGroupCardDTO, FormSchemeValues as UpdateMembershipGroupCardFormSchemaValues };
